import { render } from "./ReportsPage.vue?vue&type=template&id=3d7a90a5&ts=true"
import script from "./ReportsPage.vue?vue&type=script&lang=ts"
export * from "./ReportsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__